var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",class:{'active': _vm.isLoading}},[_c('div',{staticClass:"icon icon-loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }